var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import React, { useEffect, memo } from "react";
import clsx from "clsx";
import { visuallyHidden } from "../utils/styles.module.css";
import * as defaultStyles from "./Link.module.css";
import withComponentDefaults from "../utils/withComponentDefaults";
import { useURLTransformer } from "../hooks";
import { filterAttributes } from "../utils";
import Icon from "./Icon";
function upperFirst(string) {
  return string[0].toUpperCase() + string.slice(1);
}
function getURLType(url) {
  if (url.startsWith("#")) {
    return "anchor";
  }
  try {
    let {
      protocol,
      hostname
    } = new URL(url);
    if (protocol && protocol !== "http:" && protocol !== "https:") {
      return protocol.substr(0, protocol.length - 1);
    }
    if (hostname) {
      return "external";
    }
  } catch {}
  return "internal";
}
export default memo(withComponentDefaults(Link, "link"));
function Link(_a) {
  var _b = _a,
    {
      as,
      components: _c = {
        ButtonElement: "button",
        InertElement: "span",
        LabelElement: "label",
        DefaultElement: "a"
      }
    } = _b,
    _d = _c,
    {
      ButtonElement = "button",
      InertElement = "span",
      LabelElement = "label",
      DefaultElement = "a"
    } = _d,
    components = __objRest(_d, ["ButtonElement", "InertElement", "LabelElement", "DefaultElement"]),
    _e = _b,
    {
      children,
      className,
      href,
      htmlFor,
      innerRef,
      onClick,
      rel,
      styles = defaultStyles,
      target,
      to,
      type,
      uri,
      url,
      showExternalIcon = true
    } = _e,
    restProps = __objRest(_e, ["as", "components", "children", "className", "href", "htmlFor", "innerRef", "onClick", "rel", "styles", "target", "to", "type", "uri", "url", "showExternalIcon"]);
  href = href != null && href !== "" ? href : to != null && to !== "" ? to : url != null && url !== "" ? url : uri != null && uri !== "" ? uri : null;
  const transformURL = useURLTransformer();
  href = transformURL(href);
  type = type || (htmlFor ? "label" : href != null ? getURLType(href) : onClick ? "button" : "inert");
  let Component = as || type === "inert" && InertElement || type === "label" && LabelElement || type === "submit" && (components["SubmitButtonElement"] || ButtonElement) || type === "reset" && (components["ResetButtonElement"] || ButtonElement) || type === "button" && ButtonElement || components[upperFirst(type) + "LinkElement"] || DefaultElement;
  if (target === "_blank") {
    rel = [...new Set([...(rel ? rel.split(/\s+/g) : []), "noopener", "noreferrer"])].join(" ");
  }
  let attributes = typeof Component === "string" ? filterAttributes(restProps) : restProps;
  return /* @__PURE__ */React.createElement(Component, __spreadProps(__spreadValues({
    href,
    onClick,
    htmlFor,
    className: clsx(className, styles.component, styles[type]),
    target,
    rel,
    type: type === "button" || type === "submit" || type === "reset" ? type : void 0
  }, attributes), {
    ref: innerRef
  }), children, target === "_blank" && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("span", {
    className: visuallyHidden
  }, "\xD6ppnas i nytt f\xF6nster"), showExternalIcon && /* @__PURE__ */React.createElement(Icon, {
    name: "external",
    className: clsx(styles.icon)
  })));
}